import { Component, OnInit, ViewChild } from '@angular/core';
import { TipoAccesos } from './accesos';
import { TotemService } from '../totem.service';
import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from '../google-analytics.service';
import { environment } from '../../environments/environment';
import { element } from 'protractor';

@Component({
  selector: 'app-servicios',
  templateUrl: './servicios.component.html',
  styleUrls: ['./servicios.component.css']
})
export class ServiciosComponent implements OnInit {
  tipoAccesos: Array<TipoAccesos> = [];
  resultAccesos: Array<TipoAccesos>;
  mapa = false;
  servicioactual;
  idactual;
  serviciosreales = [];
  serviciosresult = [];
  serviciosel;
  zoomactivo = true;
  rutaalt = false;
  opcionmapa = 'totem';
  rutaenviar = environment.tipoTransporte.pie;
  planos: Array<any>;

  constructor(
    private totemService: TotemService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private activeRoute: ActivatedRoute
  ) {}

  async ngOnInit() {
    const params = this.activeRoute.snapshot.paramMap;

    await this.totemService.getTotemConfig();
    // logica pra los planos
    this.planos = await this.totemService.getPlanos().toPromise();
    for (const plano of this.planos) {
      const numero = plano.piso_numero;
      if (numero > 0 ) {
      plano.nombre = 'N' + String(numero);
      } else {
        const piso = numero.toString()[1];
        plano.nombre = 'S' + piso;
      } if (numero == 0) {
        const piso = numero.toString()[1];
        plano.nombre = 'N0' ;
      }
      
    }

    const tipoAccesos = await this.totemService.getTipoAccesos().toPromise();
    this.serviciosresult = tipoAccesos.map(
      tipoAcceso => new TipoAccesos(tipoAcceso)
    );
    for (const ser of this.serviciosresult) {
      if (ser.Visible === 1) {
        this.serviciosreales.push(ser);
      }
    }
    this.tipoAccesos = this.serviciosreales;
    if (params.get('id')) {
      this.opcionmapa = 'servicios';
      this.idactual = params.get('id');
      this.serviciosel = Number(this.idactual);
      const elser = this.tipoAccesos.find(( element ) => {
        return element.id === Number(this.idactual);
      });
      this.servicioactual = elser.nombre;
      // console.log('servicios lel',this.tipoAccesos);
    } else {
      this.serviciosel =  this.tipoAccesos[0].id;
    }
  }
  public servicioselec(servicio) {
    this.cancelartimer();
    this.opcionmapa = 'servicios';
    this.servicioactual = servicio.nombre;
    this.idactual = servicio.id;
    this.serviciosel = servicio.id;
    this.enviarEventoFiltro(servicio);
    console.log('serv', this.servicioactual, this.idactual);
  }
  public iconoruta() {
    if (this.rutaenviar === environment.tipoTransporte.pie) {
      this.rutaenviar = environment.tipoTransporte.alternativo;
    } else {
      this.rutaenviar = environment.tipoTransporte.pie;
    }
    this.cancelartimer();
    this.rutaalt = !this.rutaalt;
  }
  public enviarEventoFiltro(servicio) {
    this.googleAnalyticsService.eventEmitter(
      'servicios',
      'filter',
      servicio
    );
  }
  hacerzoom() {
    this.cancelartimer();
    this.zoomactivo = !this.zoomactivo;
    console.log('zoom activo', this.zoomactivo);
  }
  // logica de reinicio
  scrollevent = (event: any): void => {
    console.log('scroll');
    this.cancelartimer();
 }
 public cancelartimer() {
   this.totemService.emitirReinicioTotem();
 }
}
